import styled from 'styled-components'
import {
  color,
  space,
  layout,
  flexbox,
  grid,
  typography,
  background,
  border,
  position,
  shadow,
  ColorProps,
  SpaceProps,
  LayoutProps,
  FlexboxProps,
  GridProps,
  TypographyProps,
  BackgroundProps,
  BorderProps,
  PositionProps,
  ShadowProps,
} from 'styled-system'

interface Theme {
  colors: {
    [key: string]: string
  }
}

interface BoxProps extends
  ColorProps,
  SpaceProps,
  LayoutProps,
  FlexboxProps,
  GridProps,
  TypographyProps,
  BackgroundProps,
  BorderProps,
  PositionProps,
  ShadowProps {
  theme?: Theme
}

const Box = styled.div<BoxProps>`
  box-sizing: border-box;
  min-width: 0;
  ${color};
  ${space};
  ${layout};
  ${flexbox};
  ${grid};
  ${typography};
  ${background};
  ${border};
  ${position};
  ${shadow};
`

export default Box 